import { IconProps } from "@/common/contracts/icon.contracts";

export const AccountPlusOutline = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6560_7058)">
        <path
          d="M15 4.01782C13.9391 4.01782 12.9217 4.43925 12.1716 5.18939C11.4214 5.93954 11 6.95696 11 8.01782C11 9.07869 11.4214 10.0961 12.1716 10.8462C12.9217 11.5964 13.9391 12.0178 15 12.0178C16.0609 12.0178 17.0783 11.5964 17.8284 10.8462C18.5786 10.0961 19 9.07869 19 8.01782C19 6.95696 18.5786 5.93954 17.8284 5.18939C17.0783 4.43925 16.0609 4.01782 15 4.01782ZM15 5.91782C16.16 5.91782 17.1 6.85782 17.1 8.01782C17.1 9.17782 16.16 10.1178 15 10.1178C14.443 10.1178 13.9089 9.89657 13.5151 9.50275C13.1212 9.10892 12.9 8.57478 12.9 8.01782C12.9 7.46087 13.1212 6.92672 13.5151 6.5329C13.9089 6.13907 14.443 5.91782 15 5.91782ZM4 7.01782V10.0178H1V12.0178H4V15.0178H6V12.0178H9V10.0178H6V7.01782H4ZM15 13.0178C12.33 13.0178 7 14.3478 7 17.0178V20.0178H23V17.0178C23 14.3478 17.67 13.0178 15 13.0178ZM15 14.9178C17.97 14.9178 21.1 16.3778 21.1 17.0178V18.1178H8.9V17.0178C8.9 16.3778 12 14.9178 15 14.9178Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6560_7058">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.0178223)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
